
import * as echarts from 'echarts'
import { computed, defineComponent, markRaw, nextTick, onBeforeUnmount, onMounted, ref, watchEffect } from 'vue'
import ChinaJSON from '@/assets/data/china.json'
import OpenChatReportApi from '@/api/OpenChatReportApi'
import { getTodayNowTime, getTodayStartTime } from '@/utils/date.util'
import { ThemeModule } from '@/store/modules/theme.module'
import { ThemeType } from '@/assets/data/theme'

export default defineComponent({
  setup () {
    let timer = 0
    const option = {
      tooltip: {
        borderWidth: 0,
        trigger: 'item',
        padding: 8
      },
      visualMap: [{
        type: 'continuous',
        min: 0,
        max: 1000,
        realtime: true,
        itemWidth: 16,
        itemHieght: 80,
        left: 20,
        bottom: 20,
        orient: 'horizontal',
        indicatorIcon: '',
        handleStyle: {
          borderCap: 'square'
        }
      }],
      geo: {
        map: 'china',
        roam: true,
        zoom: 1.2,
        layoutCenter: ['50%', '70%'],
        layoutSize: '100%',
        itemStyle: {
          color: 'rgba(24, 144, 255, 0.1)'
        },
        emphasis: {
          itemStyle: {
            areaColor: 'rgba(24, 144, 255, 0.2)'
          }
        },
        select: {
          itemStyle: {
            areaColor: '#1890FF'
          }
        }
      },
      series: [
        {
          type: 'map',
          map: 'china',
          geoIndex: 0,
          zoom: 1.25,
          data: []
        }
      ]
    }
    const myChart = ref<echarts.ECharts>()
    const themeColors = computed(() => ThemeModule.themeColors)
    const theme = computed(() => ThemeModule.themeType)

    watchEffect(() => {
      if (theme.value === ThemeType.THEME_DARK) {
        myChart.value && myChart.value.setOption({
          tooltip: {
            extraCssText: 'background: linear-gradient(304.17deg, rgba(36, 176, 255, 0.6) -6.04%, rgba(9, 67, 132, 0.6) 85.2%); border-radius: 6px',
            formatter: (params) => {
              return `
                <div class="fs12 color-08">${params.name}</div>
                <div class="fs12 color-08" style="
                  min-width: 164px;
                  margin-top: 4px;
                  width: 100%;
                  height: 32px;
                  line-height:32px;
                  background: linear-gradient(90deg, #0E42D2 0%, #52C5FF 101.59%);
                  border-radius: 4px;
                  padding: 0 8px
                ">
                  <span>咨询</span>
                  <span style="float: right">${params.value || '-'}</span>
                </div>
              `
            }
          },
          visualMap: [{
            textStyle: {
              color: themeColors.value['font-color-06']
            },
            inRange: {
              color: ['#12131A', '#2D7EE7', '#1890FF']
            }
          }],
          geo: {        
            itemStyle: {
              borderColor: themeColors.value['main-bg-color']
            },
            emphasis: {
              label: {
                color: '#fff'
              }
            },
            select: {
              label: {
                color: '#fff'
              }
            }
          }
        })
      } else if (theme.value === ThemeType.THEME_BRIGHT) {
        myChart.value && myChart.value.setOption({
          tooltip: {
            extraCssText: 'background: linear-gradient(300.16deg, rgba(47, 129, 232, 0.6) 2.92%, rgba(78, 189, 253, 0.6) 84.87%); border-radius: 6px',
            formatter: (params) => {
              return `
                <div class="fs12 color-08">${params.name}</div>
                <div class="fs12 color-08" style="
                  min-width: 164px;
                  margin-top: 4px;
                  width: 100%;
                  height: 32px;
                  line-height:32px;
                  background: rgba(255, 255, 255, 0.8);
                  box-shadow: 6px 0px 20px rgba(34, 87, 188, 0.1);
                  border-radius: 4px;
                  padding: 0 8px
                ">
                  <span>咨询</span>
                  <span style="float: right">${params.value || '-'}</span>
                </div>
              `
            }
          },
          visualMap: [{
            textStyle: {
              color: themeColors.value['font-color-06']
            },
            inRange: {
              color: ['#F7F8FA', '#2D7EE7', '#1890FF']
            }
          }],
          geo: {        
            itemStyle: {
              borderColor: themeColors.value['main-bg-color']
            },
            emphasis: {
              label: {
                color: '#000'
              }
            },
            select: {
              label: {
                color: '#000'
              }
            }
          }
        })
      }
    })
  
    function renderChart () {
      const chartDom = document.getElementById('chat-china-map') as HTMLElement;
      myChart.value = markRaw(echarts.init(chartDom))
      echarts.registerMap('china', JSON.stringify(ChinaJSON))
      myChart.value.setOption(option);
      chartDom.removeAttribute("_echarts_instance_")
    }

    function countChatRequestLocationDistribution () {
      OpenChatReportApi.countChatRequestLocationDistribution({
        startDate: getTodayStartTime(),
        endDate: getTodayNowTime()
      }).then((res: any) => {
        const max = (res && res.length > 0) ? res.reduce((a, b) => Math.max(a, b.value), 0) : 1000
        myChart.value && myChart.value.setOption({
          visualMap: {
            max: max < 10 ? 10 : max
          },
          series: [
            {
              data: res
            }
          ]
        })
        timer = setTimeout(() => {
          countChatRequestLocationDistribution();
        }, 10000)
      })
    }

    function reasize () {
      myChart.value && myChart.value.resize()
    }

    onMounted(() => {
      renderChart()
      countChatRequestLocationDistribution();
      window.addEventListener('resize', reasize)
    })

    onBeforeUnmount(() => {
      clearTimeout(timer)
    })

    return {}
  }
})
